/**
 * Runs fetches one at a time. useApi aborts the previous call when a new one starts,
 * so overlapping filter-option loads would cancel each other.
 */
export function createSerialFetch<TConfig, TResult>(
	fetchData: (config: TConfig) => Promise<TResult>
): (config: TConfig) => Promise<TResult> {
	let tail: Promise<void> = Promise.resolve();

	return config => {
		const run = tail.then(() => fetchData(config));
		tail = run.then(
			() => undefined,
			() => undefined
		);
		return run;
	};
}
